import React from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { GitFork, MessagesSquare, Megaphone, Images, Gem } from "lucide-react";

const tabs = [
  { to: "/lineage", label: "Lineage", icon: GitFork, testid: "nav-lineage-tab" },
  { to: "/hangouts", label: "Hangouts", icon: MessagesSquare, testid: "nav-hangouts-tab" },
  { to: "/reunions", label: "Reunions", icon: Megaphone, testid: "nav-reunions-tab" },
  { to: "/memories", label: "Memories", icon: Images, testid: "nav-memories-tab" },
  { to: "/vault", label: "The Vault", icon: Gem, testid: "nav-vault-tab" },
];

export function BottomNav() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 fv-bottom-nav">
      <div className="glass mx-3 mb-3 rounded-2xl px-1.5 py-2" style={{ boxShadow: "0 8px 32px rgba(0,0,0,0.5)", marginBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}>
        <div className="grid grid-cols-5">
          {tabs.map((t) => (
            <NavLink key={t.to} to={t.to} data-testid={t.testid}>
              {({ isActive }) => (
                <motion.div
                  whileTap={{ scale: 0.9 }}
                  className="flex flex-col items-center gap-1 py-1.5 rounded-xl relative"
                >
                  {isActive && (
                    <motion.div
                      layoutId="nav-active"
                      className="absolute inset-0 rounded-xl"
                      style={{ background: "rgba(124,131,255,0.12)", border: "1px solid rgba(124,131,255,0.25)" }}
                    />
                  )}
                  <t.icon
                    size={21}
                    strokeWidth={isActive ? 2.2 : 1.7}
                    style={{ color: isActive ? "var(--accent)" : "var(--text-secondary)", zIndex: 1 }}
                  />
                  <span
                    className="text-[10px] font-medium tracking-wide relative"
                    style={{ color: isActive ? "var(--accent)" : "var(--text-muted)", zIndex: 1 }}
                  >
                    {t.label}
                  </span>
                </motion.div>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
}
